import MultipleCoupons from "@/models/loyaltyPanel/MultipleCoupons";

export default {
    namespaced: true,

    state: () => ({
        multipleCoupons: [],
        multipleCoupon: new MultipleCoupons(),
        successCode: false,
        couponClaims: [],
        exportedFile: null,
        pagination:{total:1, total_pages:1},
        claimsPagination:{total:1, total_pages:1}
    }),

    mutations: {
        setMultipleCoupons(state, payload) {
            state.multipleCoupons = payload;
        },
        setMultipleCoupon(state, payload) {
            state.multipleCoupon = new MultipleCoupons(payload);
        },
        setSuccessCode(state, payload) {
            state.successCode = payload;
        },
        setCouponClaims(state, payload) {
            state.couponClaims =payload;
        },
        setPagination(state, payload) {
            state.pagination =payload;
        },
        setClaimsPagination(state, payload) {
            state.claimsPagination =payload;
        },
        setExportedFile(state, payload) {
            state.exportedFile =payload;
        }
    },

    actions: {
        async getItems({ commit }, query) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await MultipleCoupons.get(query);
                
                const { multiple_coupons, pagination } = data.data;

                multiple_coupons.map(coupon => {
                    coupon.price = coupon.price ? coupon.price : "-"
                    coupon.maximum = coupon.maximum ? coupon.maximum : "-"
                })

                commit("setMultipleCoupons", multiple_coupons);
                commit("setPagination", pagination);
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data.message);
            }
        },

        async createCoupon({ commit, dispatch, state }) {
            try {
                commit("setLoading", true, { root: true });
                commit("setSuccessCode", false)
                const notification = state.multipleCoupon.notification
                if (
                    !notification.all_coupons_report.emails[0] &&
                    !notification.all_coupons_report.emails[1] &&
                    !notification.all_coupons_report.emails[2] &&
                    !notification.all_coupons_report.frequency &&
                    !notification.redeemed_coupons_report.emails[0] &&
                    !notification.redeemed_coupons_report.emails[1] &&
                    !notification.redeemed_coupons_report.emails[2] &&
                    !notification.redeemed_coupons_report.frequency
                ){
                    delete state.multipleCoupon.notification
                }

                const { data } = await MultipleCoupons.create(state.multipleCoupon);

                if(data.code == 200) {
                    commit("setSuccessCode", true)
                }

                dispatch("getItems","?page=1")
                state.multipleCoupon = new MultipleCoupons()
                commit("setDialog", false, { root: true });
                commit("setErrorMessage",
                    "", { root: true }
                );
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully created a new Coupon!"
                    },
                    {root: true}
                );
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage",
                    ex.response.data.message, { root: true }
                );
            }
        },
        
        async getCouponClaims({ commit }, {id, query}) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await MultipleCoupons.getCouponClaims(id, query);
                
                const { coupon_claims, pagination } = data.data;

                commit("setCouponClaims", coupon_claims);
                commit("setClaimsPagination", pagination);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data.message);
            }
        },
        
        async exportFile({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });

                const {data} = await MultipleCoupons.exportFile(body)
                commit("setExportedFile", data.data)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response?.data?.message
                    },

                    { root: true }
                );
            }
        },

        async getExportedFile({ commit }) {
            try {
                const {data} = await MultipleCoupons.getExportedFile()
                commit("setExportedFile", data.data)
            } catch (ex) {
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async deleteExportedFile({ commit }, id) {
            try {
                commit("setLoading", true, { root: true });

                await MultipleCoupons.deleteExportedFile(id)
                commit("setExportedFile", null)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },
    }
};
